import { type ProcurementTexts, procurementFieldLabel } from "@nexxt/procurement-ui";
import { m } from "../../../paraglide/messages.js";
import { mappingLabel } from "../code-mapping/code-mapping-texts";

// The words of the fields procurement names in its issues and history that the screens of @nexxt/procurement-ui do
// not (ADR-169, ADR-171): what only Tomorrow types of an inbound (packing list, messages to the systems), the tolerance
// bands and the code mappings. Registered when the app starts.

const fieldLabels: Record<string, () => string> = {
  // the packing list Logistics types (ADR-131)
  packingListLines: m.inbound_field_packing_list_lines,
  packingListUnits: m.inbound_field_packing_list_units,
  qty: m.packing_list_col_qty,
  cartons: m.packing_list_col_cartons,
  cartonRef: m.packing_list_col_carton_ref,
  // the inbound towards the systems (ADR-137): the ids Business Central lacks, its messages and their states
  po: m.inbound_field_purchase_order,
  check: m.check_tab,
  message: m.inbound_field_message,
  asnSyncStatus: m.inbound_sync_asn,
  asnSyncRevision: m.sync_field_revision,
  invoiceSyncStatus: m.inbound_sync_invoice,
  invoiceSyncRevision: m.sync_field_revision,
  // the delivery tolerance bands (V-02, ADR-128)
  brandOrgId: m.col_brand,
  minQty: m.tolerance_band_from,
  maxQty: m.tolerance_band_to,
  tolerancePct: m.tolerance_band_pct,
};

export const procurementTexts: ProcurementTexts = {
  // a mapping issue names the reference value and the system that lacks its code
  fieldText: (field) => mappingLabel(field, procurementFieldLabel) ?? fieldLabels[field]?.(),
};
